import gql from 'graphql-tag';
import { USER_FRAGMENT } from 'libs/graphql/fragment/userFragment';

export const LOGIN_EMAIL_MUTATION = gql`
    mutation LoginEmail($email: String!, $password: String!) {
        loginUser(emailOrUserId: $email, password: $password) {
            accessToken
            tokenType
            user {
                ...FUser
            }
        }
    }
    ${USER_FRAGMENT}
`;

export const LOGIN_GOOGLE_MUTATION = gql`
    mutation LoginGoogle($token: String!) {
        loginUserByGoogle(token: $token) {
            accessToken
            tokenType
            user {
                ...FUser
            }
        }
    }
    ${USER_FRAGMENT}
`;

export const LOGIN_FACEBOOK_MUTATION = gql`
    mutation LoginFacebook($token: String!) {
        loginUserByFacebook(token: $token) {
            accessToken
            tokenType
            user {
                ...FUser
            }
        }
    }
    ${USER_FRAGMENT}
`;

export const SEND_RESET_LINK_MUTATION = gql`
    mutation SendResetLink($email: String!) {
        sendResetPasswordLink(email: $email) {
            ...FUser
        }
    }
    ${USER_FRAGMENT}
`;

export const CLOSE_ACCOUNT_MUTATION = gql`
    mutation CloseAccount {
        closeUserAccount {
            success
        }
    }
`;

export const REGISTER_USER_MUTATION = gql`
    mutation RegisterUserByEmail(
        $userInfo: UserInfoRegisterInput
        $email: String!
        $password: String!
        $confirmPassword: String!
    ) {
        registerUserByEmail(
            userInfo: $userInfo
            email: $email
            password: $password
            confirmPassword: $confirmPassword
        ) {
            ...FUser
        }
    }
    ${USER_FRAGMENT}
`;

export const REGISTER_USER_BY_ADMIN_MUTATION = gql`
    mutation RegisterUserByAdmin(
        $userId: String!
        $email: String!
        $password: String!
        $confirmPassword: String!
    ) {
        registerUserByAdmin(
            userId: $userId
            email: $email
            password: $password
            confirmPassword: $confirmPassword
        ) {
            userId
        }
    }
`;

export const CHANGE_USER_SUBSCRIPTION_BY_ADMIN_MUTATION = gql`
    mutation ChangeUserSubscriptionByAdmin(
        $userId: String!
        $input: ChangeUserSubscriptionByAdminInput!
    ) {
        changeUserSubscriptionByAdmin(userId: $userId, input: $input) {
            userId
            userAccessLevel
        }
    }
`;

export const CHANGE_USER_PASSWORD_MUTATION = gql`
    mutation ChangeUserPassword(
        $currentPassword: String!
        $newPassword: String!
        $newConfirmPassword: String!
    ) {
        changeUserPassword(
            currentPassword: $currentPassword
            newPassword: $newPassword
            newConfirmPassword: $newConfirmPassword
        ) {
            userId
        }
    }
`;

export const RESET_USER_PASSWORD_MUTATION = gql`
    mutation ResetUserPassword(
        $email: String!
        $hash: String!
        $password: String!
        $confirmPassword: String!
    ) {
        resetUserPassword(
            email: $email
            hash: $hash
            password: $password
            confirmPassword: $confirmPassword
        ) {
            accessToken
            tokenType
            user {
                ...FUser
            }
        }
    }

    ${USER_FRAGMENT}
`;

export const CONFIRM_USER_EMAIL_MUTATION = gql`
    mutation ConfirmEmail($email: String!, $hash: String!) {
        confirmEmail(email: $email, hash: $hash) {
            accessToken
            tokenType
            user {
                ...FUser
            }
        }
    }

    ${USER_FRAGMENT}
`;

export const USER_SAVE_PROMOTION_ACTION = gql`
    mutation SavePromotionAction($promotionId: String!, $action: String!) {
        savePromotionAction(promotionId: $promotionId, action: $action) {
            ...FUser
        }
    }

    ${USER_FRAGMENT}
`;
